import React from "react";
import { MenuIcon } from "@components/icons";
import { MenuWithNotificationIcon } from "@components/icons/common/MenuWithNotificationIcon";
import { useUnreadMessagesCount } from "@hooks/useUnreadMessagesCount";
import { useSidebarStore } from "@store/sidebar/sidebar";

export const TopBarMenuIcon: React.FC = () => {
  const { setOpen } = useSidebarStore();
  const count = useUnreadMessagesCount();

  const Icon = count > 0 ? MenuWithNotificationIcon : MenuIcon;

  return (
    <span className="relative cursor-pointer lg:hidden">
      <Icon onClick={() => setOpen(true)} />
      {count > 0 && (
        <span className="bg-notification-red absolute right-[-6px] top-0 size-3 rounded-full" />
      )}
    </span>
  );
};
